import type { Schedule } from '../schemas';
import { mockWorkflows } from './mockWorkflows';

// Generate mock schedules for testing
export const mockSchedules: Schedule[] = (() => {
  const scheduleTemplates = [
    {
      name: 'Daily Sales Report Schedule',
      cronExpression: '0 1 * * *', // Daily at 1:00 AM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Weekly User Analytics',
      cronExpression: '0 6 * * 1', // Weekly on Monday at 6:00 AM
      timezone: 'America/New_York',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: true,
    },
    {
      name: 'Monthly Inventory Check',
      cronExpression: '0 2 1 * *', // Monthly on 1st at 2:00 AM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_month' },
      isActive: false,
    },
    {
      name: 'Hourly Customer Feedback',
      cronExpression: '0 * * * *', // Every hour
      timezone: 'Europe/London',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Bi-weekly Financial Report',
      cronExpression: '0 3 */14 * *', // Every 14 days at 3:00 AM
      timezone: 'America/Chicago',
      dateRange: { type: 'relative' as const, value: 'last_30_days' },
      isActive: true,
    },
    {
      name: 'Daily Marketing Metrics',
      cronExpression: '0 8 * * *', // Daily at 8:00 AM
      timezone: 'America/Los_Angeles',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Weekly Attendance Report',
      cronExpression: '0 9 * * 5', // Weekly on Friday at 9:00 AM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: false,
    },
    {
      name: 'Daily Product Analytics',
      cronExpression: '0 4 * * *', // Daily at 4:00 AM
      timezone: 'Asia/Tokyo',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Hourly Website Traffic',
      cronExpression: '30 * * * *', // Every hour at 30 minutes
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Weekly Support Tickets',
      cronExpression: '0 10 * * 1', // Weekly on Monday at 10:00 AM
      timezone: 'America/New_York',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: false,
    },
    {
      name: 'Monthly Subscription Report',
      cronExpression: '0 5 1 * *', // Monthly on 1st at 5:00 AM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_month' },
      isActive: true,
    },
    {
      name: 'Daily Social Media Stats',
      cronExpression: '0 7 * * *', // Daily at 7:00 AM
      timezone: 'Europe/Paris',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Weekly Email Campaign Analysis',
      cronExpression: '0 11 * * 2', // Weekly on Tuesday at 11:00 AM
      timezone: 'America/Denver',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: false,
    },
    {
      name: 'Real-time API Monitoring',
      cronExpression: '*/15 * * * *', // Every 15 minutes
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Daily Shipping Report',
      cronExpression: '0 6 * * *', // Daily at 6:00 AM
      timezone: 'Australia/Sydney',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: true,
    },
    {
      name: 'Quarterly Business Review',
      cronExpression: '0 12 1 */3 *', // Quarterly on 1st at 12:00 PM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'last_quarter' },
      isActive: false,
    },
    {
      name: 'Weekend Data Backup',
      cronExpression: '0 23 * * 6', // Weekly on Saturday at 11:00 PM
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: true,
    },
    {
      name: 'Mid-day Performance Check',
      cronExpression: '0 12 * * *', // Daily at 12:00 PM
      timezone: 'America/New_York',
      dateRange: { type: 'relative' as const, value: 'current_month' },
      isActive: true,
    },
    {
      name: 'Early Morning Data Sync',
      cronExpression: '0 0 * * *', // Daily at midnight
      timezone: 'UTC',
      dateRange: { type: 'relative' as const, value: 'previous_day' },
      isActive: false,
    },
    {
      name: 'End of Week Summary',
      cronExpression: '0 18 * * 5', // Weekly on Friday at 6:00 PM
      timezone: 'Europe/Berlin',
      dateRange: { type: 'relative' as const, value: 'last_7_days' },
      isActive: true,
    },
  ];

  const schedules: Schedule[] = [];
  const userIds = ['1', '2']; // Admin and regular user

  scheduleTemplates.forEach((template, index) => {
    const userId = userIds[index % userIds.length];
    const workflowId = mockWorkflows[index % mockWorkflows.length]?.id || '1';
    const createdDate = new Date(
      2024,
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1,
    );
    const updatedDate = new Date(createdDate.getTime() + Math.random() * 30 * 24 * 60 * 60 * 1000);

    schedules.push({
      id: (index + 1).toString(),
      ...template,
      workflowId,
      userId,
      createdAt: createdDate.toISOString(),
      updatedAt: updatedDate.toISOString(),
    });
  });

  return schedules;
})();
